export const API = Object.freeze({
  VALIDATE_TOKEN: '/accesstoken/validation',
  DEVICE_CONTROL_ENDPOINT: deviceId => `/v2/hrm/devices/${deviceId}/controls`,
  //authentication api
  AUTH_ENDPOINT: '/oauth/token',
  //devices
  DEVICES_INFORMATION: deviceId => `/v2/hrm/devices/${deviceId}/information`,
  SMARTTHINGS_DATA: deviceId => `/v2/hrm/devices/${deviceId}/smartthings-data`,
  POST_DEVICE_RM_STATE: uuid => `/v2/hrm/devices/${uuid}/rmstate`,
  POST_DEVICE_RM_STATE_PINCODE_FORCED: (uuid, deviceType) =>
    `/v2/hrm/devices/rmstate/${uuid}/${deviceType}/pincode/forced`,
  GET_DEVICE_TYPE: (selectedDeviceType, pinCode) =>
    `/v2/hrm/devices/rmstate/${selectedDeviceType}/pincode/${pinCode}`,
  GET_DEVICE_TYPE_USING_PINCODE_AND_UUID: (uuid, selectedDeviceType, pinCode) =>
    `/v2/hrm/devices/rmstate/${uuid}/${selectedDeviceType}/pincode/${pinCode}`,
  DEVICE_ERROR_HISTORY: devceId => `/v2/hrm/devices/${devceId}/errorhistory`,
  DEVICE_OPERATION_HISTORY: devceId =>
    `/v2/hrm/devices/${devceId}/operationhistory`,
  SAVE_DATA: '/v2/hrm/multi/devices/saveData',

  SAVE_RESULT_APIENDPOINT: svcId => `/v2/hrm/service/svcresult2/${svcId}`,
  //devices
  DEVICE_ANALYTICS_SYMPTOM: deviceId => `/v2/hrm/devices/${deviceId}/analytics`,
  DEVICE_ERROR_SYMPTOM: deviceUUID => `/v2/hrm/devices/${deviceUUID}/errors`,
  DEVICE_ANALYTICS_SUMMARY: deviceUUID =>
    `/v2/hrm/devices/${deviceUUID}/analytics/summary`,
  DEVICE_ANALYTICS_FEEDBACK: deviceUUID =>
    `/v2/hrm/devices/${deviceUUID}/analytics/feedback`,
  AGENT_FEEDBACK: '/v2/hrm/feedback/agent',
  DEVICE_STATES: deviceUUID => `/v2/hrm/devices/${deviceUUID}/states`,
  DEVICE_TIMEZONE: deviceUUID => `/v2/hrm/devices/${deviceUUID}/timezone`,
  DEVICE_TEMPERATURE_CONTROL: deviceUUID =>
    `/v2/hrm/devices/${deviceUUID}/temperatures/ref`,
  DEVICE_TEMPERATURE_CONTROL_CUBE_REF: deviceUUID =>
    `/v2/hrm/devices/${deviceUUID}/temperatures`,
  DEVICE_WINECELLAR_TEMPERATURE_CONTROL: deviceUUID =>
    `/v2/hrm/devices/${deviceUUID}/temperatures`,
  DEVICE_REFRIGERATION_CONTROL: deviceUUID =>
    `/v2/hrm/devices/${deviceUUID}/refrigeration`,
  DEVICE_SERVICE_OPTION_COOLING: (deviceUUID, option) =>
    `/v2/hrm/devices/${deviceUUID}/serviceoption/${option}`,
  DEVICE_ICEMAKER_ONE_CONTROL: deviceUUID =>
    `/v2/hrm/devices/${deviceUUID}/icemakerOne/0`,
  DEVICE_ICEMAKER_TWO_CONTROL: deviceUUID =>
    `/v2/hrm/devices/${deviceUUID}/icemakerTwo`,
  DEVICE_ICEMAKER_THREE_CONTROL: deviceUUID =>
    `/v2/hrm/devices/${deviceUUID}/icemakerThree`,
  DEVICE_FORCE_DEFROST: deviceUUID =>
    `/v2/hrm/devices/${deviceUUID}/forcedeforst`,
  DEVICE_DEFROST: deviceUUID => `/v2/hrm/devices/${deviceUUID}/deforst`,
  DEVICE_ICE_MAKER_RESET: deviceUUID =>
    `/v2/hrm/devices/${deviceUUID}/icemakerreset`,
  DEVICE_NIGHT_ICE_MAKING: (deviceUUID, modeId) =>
    `/v2/hrm/devices/${deviceUUID}/mode/${modeId}`,
  DEVICE_SPECIAL_ZONE_BEVERAGE: (deviceUUID, zoneId) =>
    `/v2/hrm/devices/${deviceUUID}/specialzone/beverageZone/${zoneId}`,
  DEVICE_ICE_MAKER: deviceUUID => `/v2/hrm/devices/${deviceUUID}/icemaker`,
  DEVICE_MODE: deviceUUID => `/v2/hrm/devices/${deviceUUID}/mode`,
  UPDATE_FHUB: deviceId => `/v2/hrm/fhub/${deviceId}/update`,
  //Multi devices
  MULTI_DEVICES_SAVE_DATA: '/v2/hrm/multi/devices/saveData',
  MULTI_DEVICES_INFORMATION: '/v2/hrm/multi/devices/information',
  UPDATE_SVC_HISTORY: '/v2/hrm/multi/devices/updateSvcEzoneHist',

  //Service information

  //Screenshot
  SCREENSHOT_START: '/v2/hrm/screenshare/start',
  SERVICE_INFORMATION: svcId => `/v2/hrm/service/information/${svcId}`,
  SERVICE_INFORMATION_UPDATE: svcId =>
    `/v2/hrm/service/information/${svcId}/update`,
  SERVICE_INFORMATION_ENDTYPE: '/v2/hrm/service/information/endtype',

  //waitdiagnosis apis
  GET_DEVICE_LIST_USING_PINCODE: (deviceType, pincode) =>
    `/v2/hrm/devices/rmstate/${deviceType}/pincode/${pincode}`,

  // Device map history
  DEVICE_MAP_HISTORY: deviceId => `/v2/hrm/devices/${deviceId}/maphistory`,
  DEVICE_RC_DIAGNOSIS: deviceId => `/v2/hrm/devices/${deviceId}/rc-diagnosis`,
  DEVICE_SMART_RESET: deviceId => `/v2/hrm/devices/${deviceId}/reset`,
  DEVICE_WINECELLAR_DEMO_MODE: () =>
    `/api/remote-diagnosis/winecellar/demo-mode`,
  SMARTTHINGS_LINK: '/v2/hrm/devices/smartthings-link',
  REPORT_MISSING_CONST: '/utils/report-missing-const',
  //Wahser state API Update
  STATE_UPDATE: (deviceUuid, endpoint) =>
    `/v2/hrm/devices/${deviceUuid}${endpoint}`,
});
